<template>
  <div class="specCount">
    <div id="specCount" class="echarts_up">
    </div>
    <el-table class="echarts_up" :row-style="rowStyle" :header-cell-style="headerStyle" :data="countData" height="100%">
      <el-table-column label="专业" align="center" prop="name"></el-table-column>
      <el-table-column label="占比" align="center" prop="proportion"></el-table-column>
      <el-table-column label="问题数" align="center" prop="num"></el-table-column>
    </el-table>
    
  </div>
</template>

<script>
import projectHome from "@/xgzdService/projectHome-service";
import { mapState } from "vuex";
import * as echarts from 'echarts';
export default {
  props:{
    type:{type:Number}
  },
  data(){
    return{
      countData:[],
      total:""
    }
  },
  computed:{
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
    }),
  },
  created(){
    this.getSpecCount()
  },
  methods:{
    async getSpecCount(){
      let specCountData=[];
      const { prjId }=this.prjInfo;
      const { data }=await projectHome.specCount(prjId,this.type);
      this.total =  data[0].totalNum
      const fixedSpecName = ['结构', '建筑']
      this.countData= data.map((item)=>{
        const order = fixedSpecName.indexOf(item.name)
        return{
          order,
          name:item.name,
          num:item.num,
          totalNum:item.totalNum,
          proportion:this.getPercent(item.num,item.totalNum)
        }
      }).sort((a, b) => b.order - a.order);

      let myChart = echarts.init(document.getElementById('specCount'));
      for(var i = 0;i < this.countData.length;i++ ){
        const obj = new Object();
        obj.name = this.countData[i].name;
        obj.value = this.countData[i].num;
        specCountData[i] = obj;
        myChart.setOption({
            tooltip: {
              trigger: "item",
              backgroundColor: "rgba(0, 0, 0, 0.62)",
              textStyle: {
                fontFamily: "PingFang SC",
                fontSize: 14,
                color: "#ffffff"
              },
              formatter(e) {
                return (
                  e.marker +
                  " " +
                  e.name +
                  "<br>" +
                  "&nbsp;&nbsp;&nbsp;&nbsp;" +
                  "问题数：" +
                  e.value +
                  "<br>" +
                  "&nbsp;&nbsp;&nbsp;&nbsp;" +
                  "占比：" +
                  e.percent+
                  "%"
                );
              }
            },
            graphic: [
              {
                //图形中间文字
                type: "text",
                left: "center",
                top: "40%",
                style: {
                  text: "总问题数",
                  textAlign: "top",
                  fill: "#666666",
                  fontSize: 14
                }
              },
              {
                type: "text",
                left: "center",
                top: "50%",
                style: {
                  text: this.total,
                  textAlign: "top",
                  fill: "#33333",
                  fontSize: 18
                }
              },
            ],
            series: [
              {
                name: "问题类型占比",
                type: "pie",
                radius: ["55%", "80%"], //环形占比
                center: ["50%", "45%"],
                avoidLabelOverlap: true,
                label: {
                  normal: {
                    show: false,
                    formatter: "{b}: {c}\n({d}%)"
                  }
                },
                labelLine: {
                  show: false,
                  normal: {
                    length: 9
                  }
                },
                itemStyle: {
                  color: function(params) {
                    //图例颜色
                    var colorList = [
                      "#5587F0",
                      "#64D7B9",
                      "#4655F0",
                      "#FFBE5A",
                      "#FA5F87",
                      "#2499FA",
                      "#93A4C9",
                      "#445287",
                      "#384268",
                      "#3791fb",
                      "#19d2d1",
                      "#56ca77",
                      "#fbd355",
                      "#fbaf55",
                      "#f1657d",
                      "#9664E2",
                      "#5358cc",
                      "#445287",
                      "#384268",
                      "#3791fb",
                      "#19d2d1",
                      "#56ca77",
                      "#fbd355",
                      "#fbaf55",
                      "#cfd1d2",
                      "#f1657d",
                      "#9664E2",
                      "#5358cc",
                      "#445287",
                      "#384268"
                    ];
                    return colorList[params.dataIndex];
                  }
                },
                data: specCountData
              }
            ]
          });
          window.onresize = myChart.resize;
      }
    },
    getPercent(num, total){
      num = parseFloat(num);
      total = parseFloat(total);
      if (isNaN(num) || isNaN(total)) {
        return "-";
      }
      return total <= 0? "0%" : Math.round((num / total) * 10000) / 100.0 + "%";
    },
    rowStyle() {
      return "height:60px";
    },
    headerStyle() {
      return "background-color: #F7F9FF;color:#2E384D;padding:6px 0;height:54px;border-top:1px solid #EFF0F9";
    },
  }
}
</script>

<style lang="scss" scoped>
.specCount{
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: relative;
  .echarts_up{
    height: 100%;
    width: 50%;
  }
}
</style>
